import { useNavigation } from 'react-router';

import { cn } from '@/shared/lib/cn';

/** Slim top progress bar while route modules / loaders are loading. */
export function NavigationProgress() {
  const navigation = useNavigation();
  const active = navigation.state !== 'idle';
  return (
    <div
      aria-hidden
      className={cn(
        'pointer-events-none fixed inset-x-0 top-0 z-[100] h-0.5 origin-left bg-brand transition-[transform,opacity] ease-out',
        active ? 'scale-x-[0.7] opacity-100 duration-[2500ms]' : 'scale-x-100 opacity-0 duration-300',
      )}
    />
  );
}
